var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v("Hups, ei löytynyt täältä.")]),_c('p',[_vm._v("Takaisin "),_c('router-link',{staticClass:"homelink",attrs:{"to":"/"}},[_vm._v("alkuun")]),_vm._v(".")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }